import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { RoleRestConnectorService } from './services/role-rest-connector.service';
import { RoleService } from './services/role-service';
import { RoleEffects } from './state/role.effects';
import { roleReducer } from './state/role.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('roles', roleReducer),
    EffectsModule.forFeature([
      RoleEffects,
    ]),
    CommonModule,
  ],
  providers: [
    RoleService,
    RoleRestConnectorService,
    RoleEffects,
  ],
  declarations: [],
})
export class RoleModule { }
